import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SmallHeader from '../../svgs/tracking/SmallHeader'
import History from './History'

import { fetchRiskAssessmentHistory } from '../../services/riskAssessments.service';
import { THEMES } from '../../dto/theme';

function ActivityLog({hasPermission,token, _id ,handlePostHistory,control}){
    const [remark, setRemark] = useState('')
    const [history, setHistory] = useState()
    const navigate = useNavigate()
    useEffect(() =>{
        handleFetchHistory()
    },[])
    async function handleFetchHistory(){
        const res = await fetchRiskAssessmentHistory(token.token, _id)
        if(res.errno) return console.log(res)
        // console.log(res)
        setHistory(res.result)
    }
    function handleSaveRemark(){
        const obj = {}
        obj.remark = remark
        handlePostHistory(obj)
        setRemark('')
        navigate('/risk-assessment')
    }
    return(<div className='flex-1 max-w-[1265px] mr-[40px]'>
        <div className='flex flex-col mb-[20px] mt-[40px]'>
            <div className='flex flex-row text-[18px] font-bold'><SmallHeader className="mr-[4px]"/>Remark</div>
        </div>
        <div className='relative h-[300px]'>
            {hasPermission && <div onClick={handleSaveRemark} className='absolute right-0 bottom-0 m-2 py-[2px] px-[16px] rounded-full text-[#63BDFF] cursor-pointer select-none' style={{backgroundColor:control.theme === THEMES.DARK ? '#00202A' : 'black'}}>
                save
            </div>}
            <textarea disabled={!hasPermission} value={remark} onChange={(e)=>{setRemark(e.target.value)}} className='w-full h-[300px] bg-transparent resize-none' style={{border:control.theme===THEMES.DARK?'1px solid #FFFFFF80':'1px solid black'}}/>
        </div>
        <div className='flex flex-col mb-[20px] mt-[40px]' style={{}}>
            <div className='flex flex-row text-[18px] font-bold'><SmallHeader className="mr-[4px]"/>History</div>
            <History isReversed={true} historyArr={history}/>
        </div>
    </div>)
}

export default connect((store) => {
    return {
      token: store.tokenReducer,
      control: store.controlReducer,
    }
})(ActivityLog)